module.exports = __webpack_public_path__ + "static/pic11-66a0bcbc58dc9c77714ebd12891a9f5e.png";